module.exports = __webpack_public_path__ + "static/img/icon8-8.1128091d.png";